'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdNextWeek = function MdNextWeek(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.4 30.9l6.6-6.8-6.6-6.6-1.8 1.6 5 5-5 5z m-1.8-22.5v3.2h6.8v-3.2h-6.8z m6.8-3.4c1.8 0 3.2 1.5 3.2 3.4v3.2h6.8c1.8 0 3.2 1.6 3.2 3.4v18.4c0 1.8-1.4 3.2-3.2 3.2h-26.8c-1.8 0-3.2-1.4-3.2-3.2v-18.4c0-1.8 1.4-3.4 3.2-3.4h6.8v-3.2c0-1.8 1.4-3.4 3.2-3.4h6.8z' })
        )
    );
};

exports.default = MdNextWeek;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/next-week.js
// module id = 992
// module chunks = 0